import { useEffect, useState } from "react";
import { get } from "../http/api";
import "./NotificationUsersModal.css";
import { UPLOADS_URL } from "../config";

export default function NotificationUsersModal({
    notificationId,
    onClose
}) {
    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            setLoading(true);

            const res = await get(
                `notifications/users/${notificationId}`
            );

            setUsers(res.data || []);

        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="notif-users-overlay"
            onClick={onClose}
        >
            <div
                className="notif-users-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <h3>Ont aimé la publication</h3>

                <div className="notif-users-list">
                    {loading ? (
                        Array.from({ length: 6 }).map((_, i) => (
                            <div
                                key={i}
                                className="notif-user-skeleton"
                            >
                                <div className="nus-avatar skeleton"></div>

                                <div className="nus-content">
                                    <div className="nus-line skeleton"></div>
                                    <div className="nus-line short skeleton"></div>
                                </div>
                            </div>
                        ))
                    ) : (
                        users.map((u) => (
                            <a
                                key={u.id}
                                href={`/user/${u.id}`}
                                className="notif-user-item"
                            >
                                <img
                                    src={
                                        u.image
                                            ? `${UPLOADS_URL}/${u.image}`
                                            : "/default-avatar.png"
                                    }
                                    alt=""
                                />

                                <div>
                                    <strong>
                                        {u.username}
                                    </strong>

                                    <span>
                                        {u.role}
                                    </span>
                                </div>
                            </a>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}